import { render, staticRenderFns } from "./TableViewPreview.vue?vue&type=template&id=0f190a12&scoped=true"
import script from "./TableViewPreview.vue?vue&type=script&lang=js"
export * from "./TableViewPreview.vue?vue&type=script&lang=js"
import style0 from "./TableViewPreview.vue?vue&type=style&index=0&id=0f190a12&lang=css&scoped=true"
import style1 from "./TableViewPreview.vue?vue&type=style&index=1&id=0f190a12&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f190a12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f190a12')) {
      api.createRecord('0f190a12', component.options)
    } else {
      api.reload('0f190a12', component.options)
    }
    module.hot.accept("./TableViewPreview.vue?vue&type=template&id=0f190a12&scoped=true", function () {
      api.rerender('0f190a12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/TableViewPreview.vue"
export default component.exports